<div>
  <div id="header">
    <app-header />
  </div>
  <div id="main">
    <div id="renderArea"></div>

    <app-annotation-container />

    <app-sidebar (profile2DClick)="onProfile2DClick($event.event, $event.id)" />

    @if (showProfileWindow()) {
      <app-profile-window
        [visible]="showProfileWindow()"
        [viewer]="viewer()"
        (visibilityChanged)="showProfileWindow.set($event)"
      />
    }
    @if (viewer()) {
      <app-compass [viewer]="viewer()" [visible]="true" />
      <app-navigation-controls />
    }
  </div>
</div>
